import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { motion } from "framer-motion";
import { SPECIALITIES } from "@/lib/site";

export const Specialities = ({ compact = false }) => {
  return (
    <section
      data-testid="specialities-section"
      aria-labelledby="specialities-heading"
      className={compact ? "py-16" : "py-20 md:py-28 bg-slate-50"}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.22em] font-semibold text-blue-700">
            Areas of Expertise
          </div>
          <h2
            id="specialities-heading"
            className="mt-4 font-serif text-3xl md:text-5xl leading-tight tracking-tight text-slate-900"
          >
            Cancer specialities treated with precision.
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            Dr. Anusha Mandava has expertise across multiple cancer types, with
            a strong focus on precision radiation therapy planning tailored to
            each patient&apos;s condition.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SPECIALITIES.map((s, idx) => {
            const Icon = Icons[s.icon] || Icons.HeartPulse;
            return (
              <motion.article
                key={s.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: idx * 0.05 }}
                data-testid={`speciality-card-${idx}`}
                className="group bg-white rounded-2xl p-6 border border-slate-100 hover:border-blue-200 hover:shadow-[0_20px_40px_-20px_rgba(30,58,138,0.2)] hover:-translate-y-1 transition-all duration-300"
              >
                <div className="h-12 w-12 rounded-xl bg-blue-50 flex items-center justify-center text-blue-700 group-hover:bg-blue-900 group-hover:text-white transition-colors">
                  <Icon className="h-6 w-6" strokeWidth={1.7} />
                </div>
                <h3 className="mt-5 font-serif text-xl text-slate-900">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                  {s.body}
                </p>
              </motion.article>
            );
          })}
        </div>

        {!compact && (
          <div className="mt-12">
            <Link
              to="/contact"
              data-testid="specialities-cta"
              className="inline-flex items-center gap-2 bg-blue-900 text-white font-semibold px-6 py-3.5 rounded-full hover:bg-blue-800 transition-colors"
            >
              Discuss Your Case →
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default Specialities;
